import React, {useCallback, useState} from 'react';
import PropTypes from 'prop-types';

const Confirm = ({config}) => {
    const [isConsentChecked, setIsConsentChecked] = useState(false);
    const [showConsentAlert, setShowConsentAlert] = useState(false);
    const [confirmUrl, setConfirmUrl] = useState(null);

    const handleConsentChange = useCallback((event) => {
        const checked = event.target.checked;

        setIsConsentChecked(checked);
        setConfirmUrl(checked ? config.confirmUrl : null);

        if (checked) {
            setShowConsentAlert(false);
        }
    }, [config.confirmUrl, setIsConsentChecked, setConfirmUrl, setShowConsentAlert]);

    const handleConfirmClick = useCallback((event) => {
        if (!isConsentChecked) {
            event.preventDefault();
            setShowConsentAlert(true);
        }
    }, [isConsentChecked, setShowConsentAlert]);

    return (
        <>
            <label className="premium-recapitulation-consent">
                <input
                    type="checkbox"
                    className="premium-recapitulation-consent__checkbox"
                    checked={isConsentChecked}
                    onChange={handleConsentChange}
                />
                {config.consentText}
            </label>

            {showConsentAlert && (
                <div className="alert alert-danger mt-3 mb-0" role="alert">
                    {config.alertText}
                </div>
            )}

            <p className="mt-4" dangerouslySetInnerHTML={{__html: config.confirmInfo}} />

            {config.openOrderWarning && (
                <div
                    className="alert alert-primary"
                    dangerouslySetInnerHTML={{__html: config.openOrderWarning}}
                />
            )}

            <a
                href={confirmUrl || undefined}
                className="btn btn--blue mt-3 text-17"
                onClick={handleConfirmClick}
                aria-disabled={!isConsentChecked}
            >
                <strong className="pe-2">
                    {config.buttonLabel}
                </strong>
                <svg
                    id="Button_Icon_Arrow_"
                    data-name="Button Icon (Arrow)"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    style={{position: 'relative', top: '-2px'}}
                >
                    <rect id="space" width="20" height="20" fill="#fff" opacity="0" />
                    <path
                        id="arrow"
                        d="M6.1,12a.888.888,0,0,1-.645-.279L0,6,5.45.279A.885.885,0,0,1,6.73.268.956.956,0,0,1,6.74,1.59L2.539,6l4.2,4.41a.956.956,0,0,1-.01,1.322A.887.887,0,0,1,6.1,12Z"
                        transform="translate(13.5 16) rotate(180)"
                        fill="#fff"
                    />
                </svg>
            </a>
        </>
    );
}

Confirm.propTypes = {
    config: PropTypes.object.isRequired
};

export default Confirm;
